import { render, staticRenderFns } from "./DelMenuGroup.vue?vue&type=template&id=3ce291c4&scoped=true"
import script from "./DelMenuGroup.vue?vue&type=script&lang=js"
export * from "./DelMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./DelMenuGroup.vue?vue&type=style&index=0&id=3ce291c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce291c4",
  null
  
)

export default component.exports